// extracted by mini-css-extract-plugin
export default {"Box":"issue-type-renderer-module__Box--xzSl_","Token":"issue-type-renderer-module__Token--S9nJD"};